//#region current user
export const FETCHING_CURRENT_USER = 'FETCHING_CURRENT_USER'
export const SET_CURRENT_USER_SUCCESS = 'SET_CURRENT_USER_SUCCESS'
export const SET_CURRENT_USER_ERROR = 'SET_CURRENT_USER_ERROR'
export const SET_CURRENT_USER_ROLES = 'SET_CURRENT_USER_ROLES'
//#endregion

//#region notifications
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'
//#endregion

//#region ref data
export const FETCHING_SKUS = 'FETCHING_SKUS'
export const FETCHING_SKUS_ERROR = 'FETCHING_SKUS_ERROR'
export const FETCHING_SKUS_SUCCESS = 'FETCHING_SKUS_SUCCESS'
export const FETCHING_ROLES = 'FETCHING_ROLES'
export const FETCHING_ROLES_ERROR = 'FETCHING_ROLES_ERROR'
export const FETCHING_ROLES_SUCCESS = 'FETCHING_ROLES_SUCCESS'
//#endregion

//#region user manager
export const CLEAR_USERS = 'CLEAR_USERS'
export const FETCHING_PRODUCT_USER = 'FETCHING_PRODUCT_USER'
export const FETCHING_PRODUCT_USER_ERROR = 'FETCHING_PRODUCT_USER_ERROR'
export const FETCHING_PRODUCT_USER_SUCCESS = 'FETCHING_PRODUCT_USER_SUCCESS'
export const FETCHING_SETUP_ADMIN_USER_ID = 'FETCHING_SETUP_ADMIN_USER_ID'
export const FETCHING_SETUP_ADMIN_USER_ID_ERROR =
  'FETCHING_SETUP_ADMIN_USER_ID_ERROR'
export const FETCHING_SETUP_ADMIN_USER_ID_SUCCESS =
  'FETCHING_SETUP_ADMIN_USER_ID_SUCCESS'
export const SAVING_PRODUCT_USER = 'SAVING_PRODUCT_USER'
export const SAVING_PRODUCT_USER_ERROR = 'SAVING_PRODUCT_USER_ERROR'
export const SAVING_PRODUCT_USER_SUCCESS = 'SAVING_PRODUCT_USER_SUCCESS'
export const SAVING_PRODUCT_USER_PAK_SUCCESS = 'SAVING_PRODUCT_USER_PAK_SUCCESS'
export const FETCHING_NETSUITE_CUSTOMER = 'FETCHING_NETSUITE_CUSTOMER'
export const FETCHING_NETSUITE_CUSTOMER_SUCCESS =
  'FETCHING_NETSUITE_CUSTOMER_SUCCESS'
export const FETCHING_NETSUITE_CUSTOMER_ERROR =
  'FETCHING_NETSUITE_CUSTOMER_ERROR'
export const FETCHING_LESSON_PROGRESS_REPORT = 'FETCHING_LESSON_PROGRESS_REPORT'
export const FETCHING_LESSON_PROGRESS_REPORT_SUCCESS =
  'FETCHING_LESSON_PROGRESS_REPORT_SUCCESS'
export const FETCHING_LESSON_PROGRESS_REPORT_ERROR =
  'FETCHING_LESSON_PROGRESS_REPORT_ERROR'
export const FETCHING_ARCHETYPES = 'FETCHING_ARCHETYPES'
export const FETCHING_ARCHETYPES_SUCCESS = 'FETCHING_ARCHETYPES_SUCCESS'
export const FETCHING_ARCHETYPES_ERROR = 'FETCHING_ARCHETYPES_ERROR'
//#endregion

//#region admin roles
export const FETCHING_ADMIN_ROLES = 'FETCHING_ADMIN_ROLES'
export const FETCHING_ADMIN_ROLES_SUCCESS = 'FETCHING_ADMIN_ROLES_SUCCESS'
export const UPDATE_ADMIN_ROLES = 'UPDATE_ADMIN_ROLES'
export const ADD_ADMIN_ROLE_SUCCESS = 'ADD_ADMIN_ROLE_SUCCESS'
export const REMOVE_ADMIN_ROLE_SUCCESS = 'REMOVE_ADMIN_ROLE_SUCCESS'
export const HANDLE_ADMIN_ROLE_ERROR = 'HANDLE_ADMIN_ROLE_ERROR'
export const SET_ADMIN_TO_REMOVE = 'SET_ADMIN_TO_REMOVE'
//#endregion

//#region subscription manager
export const FETCHING_SUBSCRIPTIONS = 'FETCHING_SUBSCRIPTIONS'
export const FETCHING_SUBSCRIPTIONS_ERROR = 'FETCHING_SUBSCRIPTIONS_ERROR'
export const SET_SUBSCRIPTIONS_SUCCESS = 'SET_SUBSCRIPTIONS_SUCCESS'
export const REPLACE_SUBSCRIPTION = 'REPLACE_SUBSCRIPTION'
export const SET_SELECTED_SUBSCRIPTION = 'SET_SELECTED_SUBSCRIPTION'
//#endregion

//#region license manager
export const FETCHING_LICENSES = 'FETCHING_LICENSES'
export const FETCHING_LICENSES_ERROR = 'FETCHING_LICENSES_ERROR'
export const FETCHING_LICENSES_SUCCESS = 'FETCHING_LICENSES_SUCCESS'
export const FETCHING_LICENSE_SUCCESS = 'FETCHING_LICENSE_SUCCESS'
export const FETCHING_SUBSCRIPTION_FOR_LICENSES =
  'FETCHING_SUBSCRIPTION_FOR_LICENSES'
export const FETCHING_LICENSES_NOT_FOUND = 'FETCHING_LICENSES_NOT_FOUND'
export const CLEAR_LICENSES = 'CLEAR_LICENSES'
export const SAVING_LICENSE = 'SAVING_LICENSE'
export const SAVING_LICENSE_ERROR = 'SAVING_LICENSE_ERROR'
export const SAVING_LICENSE_SUCCESS = 'SAVING_LICENSE_SUCCESS'
export const SET_LICENSE_SEARCH_QUERY = 'SET_SEARCH_QUERY'
export const TOGGLE_RESULTS_PAGE = 'TOGGLE_RESULTS_PAGE'
export const SENDING_LICENSE_USER = 'license/SENDING_LICENSE_USER'
export const SENDING_LICENSE_USER_SUCCESS =
  'license/SENDING_LICENSE_USER_SUCCESS'
export const SENDING_LICENSE_USER_ERROR = 'license/SENDING_LICENSE_USER_ERROR'
export const SENDING_LICENSE_USER_BULK = 'license/SENDING_LICENSE_USER_BULK'
export const SENDING_LICENSE_USER_BULK_SUCCESS =
  'license/SENDING_LICENSE_USER_BULK_SUCCESS'
export const SENDING_LICENSE_USER_BULK_ERROR =
  'license/SENDING_LICENSE_USER_BULK_ERROR'
export const RESET_BULK_ADD_USERS = 'license/RESET_BULK_ADD_USERS'
export const DELETING_LICENSE_USER = 'license/DELETING_LICENSE_USER'
export const DELETING_LICENSE_USER_SUCCESS =
  'license/DELETING_LICENSE_USER_SUCCESS'
export const DELETING_LICENSE_USER_ERROR = 'license/DELETING_LICENSE_USER_ERROR'
export const GRANTING_NEW_ROLE_LICENSE_USER =
  'license/GRANTING_NEW_ROLE_LICENSE_USER'
export const GRANTING_NEW_ROLE_LICENSE_USER_SUCCESS =
  'license/GRANTING_NEW_ROLE_LICENSE_USER_SUCCESS'
export const GRANTING_NEW_ROLE_LICENSE_USER_ERROR =
  'license/GRANTING_NEW_ROLE_LICENSE_USER_ERROR'
//#endregion

//#region lmsManager
export const FETCHING_LMS_CHILD_MODULE_STATUSES =
  'FETCHING_LMS_CHILD_MODULE_STATUSES'
export const FETCHING_LMS_CHILD_MODULE_STATUSES_SUCCESS =
  'FETCHING_LMS_CHILD_MODULE_STATUSES_SUCCESS'
export const FETCHING_LMS_CHILD_MODULE_STATUSES_ERROR =
  'FETCHING_LMS_CHILD_MODULE_STATUSES_ERROR'
export const UPDATING_LMS_TRAINING_PATH = 'UPDATING_LMS_TRAINING_PATH'
export const UPDATING_LMS_TRAINING_PATH_SUCCESS =
  'UPDATING_LMS_TRAINING_PATH_SUCCESS'
export const UPDATING_LMS_TRAINING_PATH_ERROR =
  'UPDATING_LMS_TRAINING_PATH_ERROR'
export const ADD_LMS_TRAINING_PATH = 'ADD_LMS_TRAINING_PATH'
export const ADD_LMS_TRAINING_PATH_SUCCESS = 'ADD_LMS_TRAINING_PATH_SUCCESS'
export const ADD_LMS_TRAINING_PATH_ERROR = 'ADD_LMS_TRAINING_PATH_ERROR'
export const CLEAR_LMS_CHILD_MODULE_STATUSES = 'CLEAR_LMS_CHILD_MODULE_STATUSES'
export const FETCHING_LMS_TRAINING_STATUSES_CSS =
  'FETCHING_LMS_TRAINING_STATUSES_CSS'
export const FETCHING_LMS_TRAINING_STATUSES_SUCCESS_CSS =
  'FETCHING_LMS_TRAINING_STATUSES_SUCCESS_CSS'
export const FETCHING_LMS_TRAINING_STATUSES_ERROR_CSS =
  'FETCHING_LMS_TRAINING_STATUSES_ERROR_CSS'
export const SET_ACTIVE_SKU_CODE = 'SET_ACTIVE_SKU_CODE'
export const IS_SAVING_TRAINING = 'IS_SAVING'
//#endregion

//#region LAT/LST
export const FETCHING_USER_LICENSES = 'FETCHING_USER_LICENSES'
export const FETCHING_USER_LICENSES_SUCCESS = 'FETCHING_USER_LICENSES_SUCCESS'
export const FETCHING_USER_LICENSES_ERROR = 'FETCHING_USER_LICENSES_ERROR'
export const HANDLING_USER_ACCESS = 'HANDLING_USER_ACCESS'
export const HANDLING_USER_ACCESS_SUCCESS = 'HANDLING_USER_ACCESS_SUCCESS'
export const HANDLING_USER_ACCESS_ERROR = 'HANDLING_USER_ACCESS_ERROR'
export const ADD_TO_SUCCESSFUL_EMAILS = 'ADD_TO_SUCCESSFUL_EMAILS'
export const ADD_TO_FAILED_EMAILS = 'ADD_TO_FAILED_EMAILS'
export const UPDATE_LICENSE = 'UPDATE_LICENSE'
//#endregion

//#region customer manager
export const FETCHING_PREVIEW_MERGE = 'FETCHING_PREVIEW_MERGE'
export const FETCHING_PREVIEW_MERGE_SUCCESS = 'FETCHING_PREVIEW_MERGE_SUCCESS'
export const FETCHING_PREVIEW_MERGE_ERROR = 'FETCHING_PREVIEW_MERGE_ERROR'
export const MERGING_CUSTOMERS = 'MERGING_CUSTOMERS'
export const MERGING_CUSTOMERS_SUCCESS = 'MERGING_CUSTOMERS_SUCCESS'
export const MERGING_CUSTOMERS_ERROR = 'MERGING_CUSTOMERS_ERROR'
//#endregion

//#region moveSiteanager
export const FETCHING_PREVIEW_MOVE_SITE = 'FETCHING_PREVIEW_MOVE_SITE'
export const FETCHING_PREVIEW_MOVE_SITE_SUCCESS =
  'FETCHING_PREVIEW_MOVE_SITE_SUCCESS'
export const FETCHING_PREVIEW_MOVE_SITE_ERROR =
  'FETCHING_PREVIEW_MOVE_SITE_ERROR'
export const MOVING_SITE = 'MOVING_SITE'
export const MOVING_SITE_SUCCESS = 'MOVING_SITE_SUCCESS'
export const MOVING_SITE_ERROR = 'MOVING_SITE_ERROR'
//#endregion

//#region DeleteUserManager
export const FETCHING_PREVIEW_DELETE_USER = 'FETCHING_PREVIEW_DELETE_USER'
export const FETCHING_PREVIEW_DELETE_USER_SUCCESS =
  'FETCHING_PREVIEW_DELETE_USER_SUCCESS'
export const FETCHING_PREVIEW_DELETE_USER_ERROR =
  'FETCHING_PREVIEW_DELETE_USER_ERROR'
export const DELETING_USER = 'DELETING_USER'
export const DELETING_USER_SUCCESS = 'DELETING_USER_SUCCESS'
export const DELETING_USER_ERROR = 'DELETING_USER_ERROR'
//#endregion

//#region DomainProviderManager (SSO-TOOL)
export const INSERTING_DOMAIN_PROVIDER = 'INSERTING_DOMAIN_PROVIDER'
export const INSERTING_DOMAIN_PROVIDER_ERROR = 'INSERTING_DOMAIN_PROVIDER_ERROR'
export const INSERTING_DOMAIN_PROVIDER_SUCCESS =
  'INSERTING_DOMAIN_PROVIDER_SUCCESS'
//#endregion

//#region Roster Actions
export const ROSTER_FILE_SELECTED = 'ROSTER_FILE_SELECTED'
export const ROSTER_FILE_SUBMITTING = 'ROSTER_FILE_SUBMITTING'
export const ROSTER_FILE_SUCCEEDED = 'ROSTER_FILE_SUCCEEDED'
export const ROSTER_FILE_ERROR = 'ROSTER_FILE_ERROR'
//#endregion

//#region Site Preferences Actions
export const SITE_PREFERENCES_FILE_SELECTED = 'SITE_PREFERENCES_FILE_SELECTED'
export const SITE_PREFERENCES_FILE_SUBMITTING =
  'SITE_PREFERENCES_FILE_SUBMITTING'
export const SITE_PREFERENCES_FILE_SUCCEEDED = 'SITE_PREFERENCES_FILE_SUCCEEDED'
export const SITE_PREFERENCES_FILE_ERROR = 'SITE_PREFERENCES_FILE_ERROR'

//#region Pacing Actions
export const PACING_FILE_SELECTED = 'PACING_FILE_SELECTED'
export const PACING_FILE_SUBMITTING = 'PACING_FILE_SUBMITTING'
export const PACING_FILE_SUCCEEDED = 'PACING_FILE_SUCCEEDED'
export const PACING_FILE_ERROR = 'PACING_FILE_ERROR'
//#endregion



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js